import React from 'react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Footer } from '../footer';

export function Header() {
  const [isOpen, setOpen] = useState(false);
  return (
    <header className="header">
      <span className="header__title">nicolas_olenev</span>
      <nav
        className={isOpen ? 'header__menu header__menu_active' : 'header__menu'}
      >
        <ul className="header__links">
          <li className="header__link">
            <NavLink to="/" onClick={() => setOpen(false)}>
              _hello
            </NavLink>
          </li>
          <li className="header__link">
            <NavLink to="/about-me" onClick={() => setOpen(false)}>
              _about_me
            </NavLink>
          </li>
          <li className="header__link">
            <NavLink to="/projects" onClick={() => setOpen(false)}>
              _projects
            </NavLink>
          </li>
          <li className="header__link">
            <NavLink to="/contact-me" onClick={() => setOpen(false)}>
              _contact_me
            </NavLink>
          </li>
        </ul>
        <div className="header__footer">
          <Footer />
        </div>
      </nav>
      <button
        className={isOpen ? 'nav-bar-btn nav-bar-btn_active' : 'nav-bar-btn'}
        onClick={() => setOpen(!isOpen)}
      >
        <span className="nav-bar-btn__line"></span>
      </button>
    </header>
  );
}
